// extracted by mini-css-extract-plugin
module.exports = {"forumToolBarContainer":"ForumToolBar_forumToolBarContainer__3BOaC","addLink":"ForumToolBar_addLink__1eYIm","toggle":"ForumToolBar_toggle__1x9_g"};